var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729",
    transform: "translate(-156.798 -1076.799)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1049",
    "data-name": "Ellipse 1049",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(162.798 1082.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M16,32A16,16,0,0,1,9.772,1.258,16,16,0,0,1,22.228,30.743,15.9,15.9,0,0,1,16,32ZM16,2a14,14,0,0,0-5.449,26.9,14,14,0,0,0,10.9-25.8A13.912,13.912,0,0,0,16,2Z",
    transform: "translate(156.798 1076.799)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/Record.6153936600ec32162a6a2d7f31a9afec.svg";
export { ForwardRef as ReactComponent };